import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=090c4a53&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=js&"
export * from "./EditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090c4a53",
  null
  
)

export default component.exports